import React from 'react';
import { Section } from '../Section';
import { Button } from '../Button';
export var Discussion = function () {
    var openDiscussion = function () {
        return window.open('https://github.com/hhimanshu/create-react-ts-starter/discussions');
    };
    return (React.createElement(Section, { title: 'Have ideas?' },
        React.createElement(Button, { title: 'Start a discussion', onClick: openDiscussion })));
};
